import React from 'react';
import styled from 'styled-components';
import { buildDataAttr, DATA_TEST } from '../../typings/data';
import colors from '../../constants/js/colors';
const StyledIcon = styled.span.withConfig({
  componentId: "IconWrapper__sc-i46xdr-0"
})(["display:inline-flex;fill:currentColor;", ";", ";"], ({
  color
}) => color && `color: ${colors[color]}`, ({
  onClick
}) => onClick && 'cursor: pointer');
export const defaultProps = {
  [DATA_TEST]: 'icon-wrapper'
};
export const IconWrapper = props => {
  const dataAttr = buildDataAttr(props, defaultProps);
  return React.createElement(StyledIcon, Object.assign({}, props, dataAttr));
};